/* import __COLOCATED_TEMPLATE__ from './input.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./input.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());